import beTwMerge from '@/utils/beTwMerge';
import { useEffect, useState } from 'react';
import { getAnchorId } from '@/utils/builderUtils';
import { IHeader } from '@/types/builder';
import useMediaQuery from '@/hooks/useMediaQuery';
import Header from './Header';

type CustomerServiceNavigationProps = {
  title: 'string';
  headers: IHeader[];
  anchorLinkID: string;
};

export default function CustomerServiceNavigation({ title, headers, anchorLinkID }: CustomerServiceNavigationProps) {
  const isTablet = useMediaQuery('(min-width: 991px)');
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>();

  useEffect(() => {
    setIsMenuOpen(isTablet);
  }, [isTablet]);

  const handleOpenMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div
      className="tw-relative tw-w-full tw-min-h-[40px] bs-tablet:tw-min-w-[223px] bs-tablet:tw-max-w-[223px]"
      {...getAnchorId(anchorLinkID)}
    >
      {title && (
        <div
          role="button"
          className={beTwMerge(
            'tw-w-full tw-py-[10px] tw-px-[1rem] tw-flex tw-flex-row tw-justify-between tw-items-center bs-tablet:tw-py-0 bs-tablet:tw-pb-[1rem] bs-tablet:tw-px-0',
            isMenuOpen ? 'tw-bg-[#4C8380]' : 'tw-bg-be-turquoise-green',
            'bs-tablet:tw-bg-transparent bs-tablet:tw-border-b bs-tablet:tw-border-b-[#E5E5E5] bs-tablet:tw-border-l-0 bs-tablet:tw-border-t-0 bs-tablet:tw-border-r-0 bs-tablet:tw-border-solid bs-tablet:tw-pointer-events-none'
          )}
          tabIndex={0}
          onClick={handleOpenMenu}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') handleOpenMenu();
          }}
        >
          <p className="tw-font-avenirmedium tw-leading-[19.12px] tw-not-italic tw-text-wrap tw-text-white tw-m-0 bs-tablet:tw-text-be-dark-gray bs-tablet:tw-font-heavy">
            {title}
          </p>
          <svg
            className={beTwMerge('tw-shrink-0 tw-w-[20px] tw-h-[20px]', isMenuOpen ? 'tw-rotate-[-180deg]' : '')}
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path d="M17 6L10 13L3 6" stroke="white" />
          </svg>
        </div>
      )}

      <div
        className={beTwMerge(
          'tw-hidden',
          isMenuOpen
            ? 'tw-absolute bs-tablet:tw-relative tw-z-10 tw-bg-white tw-w-full tw-block tw-px-[1rem] bs-tablet:tw-px-0'
            : ''
        )}
      >
        {headers?.map((header: IHeader, index: number) => <Header key={index} {...header} />)}
      </div>
    </div>
  );
}
